"use client";
import useTranslate from "@app/_hooks/useTranslate";
import { useMarket } from "@app/_context";
import { Heading } from "@components/ui";

import { isAdyenCheckoutEnabled } from "@/config/checkout";

import { useCheckoutContext } from "../Checkout.hooks";
import { checkoutStore } from "../Checkout.store";
import CheckoutTextInput from "../CheckoutTextInput";
import CheckoutCountrySelect from "./CheckoutCountrySelect";

export default function CheckoutDeliveryAddressFields() {
  const t = useTranslate();
  const marketConfig = useMarket().state.market;
  useCheckoutContext();
  const hasSeparateDeliveryAddress = checkoutStore(
    (state) => state.hasSeparateDeliveryAddress,
  );

  if (
    isAdyenCheckoutEnabled({ marketConfig }) === false ||
    hasSeparateDeliveryAddress === false
  ) {
    return null;
  }

  return (
    <>
      {t("checkoutAddressHeading", { strict: true }) && (
        <Heading size={5} className="col-span-2 my-4 text-center">
          {t("checkoutDeliveryAddressHeading")}
        </Heading>
      )}
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={t("firstName")}
        name="deliveryFirstName"
        type="text"
      />
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={t("lastName")}
        name="deliveryLastName"
        type="text"
      />
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={t("street")}
        name="deliveryLine1"
        type="text"
      />
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={t("zipCode")}
        name="deliveryZipCode"
        type="text"
      />
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={t("city")}
        name="deliveryCity"
        type="text"
      />
      <CheckoutCountrySelect
        name="deliveryCountry"
        label={t("country")}
      />
    </>
  );
}
